import { render, staticRenderFns } from "./updateAdmin.vue?vue&type=template&id=1b516a27&scoped=true&"
import script from "./updateAdmin.vue?vue&type=script&lang=js&"
export * from "./updateAdmin.vue?vue&type=script&lang=js&"
import style0 from "./updateAdmin.vue?vue&type=style&index=0&id=1b516a27&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b516a27",
  null
  
)

export default component.exports